<template>
  <v-app id="app" :class="{ 'has-dux-rail-app': showDuxRail }">
    <UniversalNav />
    <div
      class="real-container-fluid"
      :class="{ 'has-dux-rail': showDuxRail }"
    >
      <div
        v-if="showDuxRail && !sidebarCollapsed"
        id="dux-desktop-rail"
        class="dux-rail-wrap"
      >
        <DesktopShell
          :room="desktopRoom"
          :can-edit-golden-record="canEditGoldenRecord"
          :can-admin-gtm="canAdminGtm"
          :can-open-gtm-maestro="canOpenGtmMaestro"
          :can-tuba-blast="canTubaBlast"
          @select="onDesktopSelect"
          @open-gold="openManageGold"
          @open-gtm="openGtmMaestro"
          @open-tuba="openTubaBlast"
        />
      </div>
      <div :class="{ 'app-desktop-main': showDuxRail }">
        <router-view />
      </div>
    </div>
  </v-app>
</template>

<script>
import UniversalNav from './components/structure/navigation/UniversalNav.vue'
import DesktopShell from './desktop/DesktopShell.vue'
import { desktopRoomFromRoute } from './desktop/desktopRoomFromRoute'
import {
  getSidebarCollapsed,
  subscribeSidebarCollapsed,
} from './desktop/desktopSidebarStorage'
import {
  isPhoneSmartyViewport,
  watchPhoneSmartyViewport,
} from './mobile/phoneSmartyViewport'

/**
 * DUX rail is app-wide on desktop so Profile/Logout stay reachable off Landing.
 * Phone Smarty: no rail (hamburger drawer unchanged).
 */
export default {
  name: 'App',
  components: { UniversalNav, DesktopShell },
  data () {
    return {
      phoneSmarty: isPhoneSmartyViewport(),
      sidebarCollapsed: getSidebarCollapsed(),
      _unwatchPhone: null,
      _unsubRail: null,
    }
  },
  computed: {
    canEditGoldenRecord () {
      return this.$store.getters.canEditGoldenRecord
    },
    canAdminGtm () {
      return this.$store.getters.canAdminGtm
    },
    canOpenGtmMaestro () {
      return this.$store.getters.canOpenGtmMaestro
    },
    canTubaBlast () {
      return this.$store.getters.canTubaBlast
    },
    isPublicRoute () {
      const name = this.$route && this.$route.name
      return name === 'home' || name === 'register' || name === 'logout' || name === 'forgot' || name === 'reset' || name === 'kickoff'
    },
    showDuxRail () {
      return (
        !this.phoneSmarty &&
        this.$store.getters.isLoggedIn &&
        this.$store.getters.hasAcceptedEula &&
        !this.isPublicRoute
      )
    },
    desktopRoom () {
      return desktopRoomFromRoute(this.$route)
    },
  },
  mounted () {
    this._unwatchPhone = watchPhoneSmartyViewport((isPhone) => {
      this.phoneSmarty = isPhone
    })
    this._unsubRail = subscribeSidebarCollapsed((collapsed) => {
      this.sidebarCollapsed = collapsed
    })
  },
  beforeDestroy () {
    if (typeof this._unwatchPhone === 'function') this._unwatchPhone()
    if (typeof this._unsubRail === 'function') this._unsubRail()
  },
  methods: {
    onDesktopSelect (id) {
      if (id === 'profile') {
        if (this.$route.name !== 'profile') this.$router.push('/profile')
        return
      }
      if (id === 'logout') {
        this.$router.push('/logout')
        return
      }
      const tab = id === 'matrix' ? 'matrix' : id
      this.$router.push({ name: 'landing', query: { tab } }).catch(() => {})
    },
    openManageGold () {
      this.$router.push({ name: 'companyConsole' })
    },
    openGtmMaestro () {
      this.$router.push({ name: 'gtmMaestro' })
    },
    openTubaBlast () {
      this.$router.push({ name: 'tubaBlast' })
    },
  },
}
</script>

<style>

.nav {
  padding: 16px;
}

.router-link-exact-active {
  font-weight: 600;
  border-bottom: 3px solid #222; 
}

html, body, #app {
    height: 100%;
    max-width: 100%;
    overflow-x: hidden;
}

/*
 * Fit the window, not a monitor. Maximized Chrome on a laptop vs an external
 * display each get their own innerWidth — extra columns/toolbar chrome must
 * scroll or shrink inside that, not widen the document. Does not move or lock
 * the OS window (intentional off-screen drags stay possible).
 */
.v-application,
.v-application--wrap {
  max-width: 100%;
  overflow-x: hidden;
}

.v-application--wrap {
  min-width: 0;
}

/* For some god awful reason, container--fluid is overridden by container. So I'm manually creating a fluid one */
.real-container-fluid {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin: 0 8px;
  overflow-x: hidden;
}

.v-application--wrap > .real-container-fluid.has-dux-rail {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

/*
 * Rail stays in the viewport. Long pages (GTM Maestro) scroll in the main
 * pane only — Tools / Account must not ride off the bottom.
 */
.v-application.has-dux-rail-app > .v-application--wrap {
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.real-container-fluid.has-dux-rail {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin: 0;
  overflow: hidden;
}
.dux-rail-wrap {
  flex: 0 0 220px;
  width: 220px;
  min-width: 220px;
  max-width: 220px;
  align-self: stretch;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
.app-desktop-main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
